package fr.manyverse.app.domain.model

import kotlin.time.Instant

data class UserConfig(
    val userId: String,
    val termsAcceptedAt: Instant?
) {
    val hasAcceptedTerms: Boolean get() = termsAcceptedAt != null
}
